import { View } from "react-native";
import React from "react";
import { Popover, Text } from "@ui-kitten/components";
import { RenderFCProp } from "@ui-kitten/components/devsupport";
import i18n from "plugins/localization";

interface ActionPopoverProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  anchor: RenderFCProp<{}>;
}
const ActionPopover: React.FC<ActionPopoverProps> = ({
  visible,
  setVisible,
  anchor,
}) => {
  return (
    <Popover
      visible={visible}
      anchor={anchor}
      onBackdropPress={() => setVisible(false)}
    >
      <View
        style={{
          width: 250,
          paddingVertical: 5,
          paddingHorizontal: 16,
          borderRadius: 4,
          backgroundColor: "rgba(97,97,97,.9)",
        }}
      >
        <Text status="control">
          {i18n.t("common.groupReservationCannotBeChanged")}
        </Text>
      </View>
    </Popover>
  );
};

export default ActionPopover;
